import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ItemDireccion from "@components/ItemDireccion";
import { TokenContext } from "@context/TokenContext";
import axios from "@fetch/axios";
import { CartContext } from "@context/CardContext";
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const DireccionEnvio = () => {
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate();
  const { getToken, getVerified } = useContext(TokenContext);
  const [direcciones, setDirecciones] = useState([]);
  const [ocultar, setOcultar] = useState(true)
  const [selectedDireccionId, setSelectedDireccionId] = useState(null);
  const [cityOptions, setCityOptions] = useState([]); // Nuevo estado para las opciones de ciudad
  const [street1, setStreet1] = useState(null);
  const [street2, setStreet2] = useState(null);
  const [cp, setCp] = useState(null);
  const [city, setCity] = useState(null);
  const [country, setCountry] = useState(142);
  const [detail, setDetail] = useState(null);
  const { translate } = useTranslation();
  const countries = JSON.parse(localStorage.getItem('countries_arteonu'));
  const API_KEY = localStorage.getItem('gg');
  const { getCardId, setTotalPay, setDescuento } = useContext(CartContext);
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(true)

  const handleSelect = (direccionId) => {
    setSelectedDireccionId(direccionId);
    setOcultar(true)
  };

  const handleEditar = (dir) => {
    setSelectedDireccionId(dir.id);
    setStreet1(dir.line)
    setStreet2(dir.line2)
    setCp(dir.postal_code)
    setDetail(dir.details)
    setCity(dir.city)
    setCountry(dir.country_id)
    setOcultar(false)
  };

  const aplicarCupon = async () => {

    if (code) {

      const itemlen= JSON.parse(localStorage.getItem('cart') ?? '[]');
      if (itemlen.length > 0) {

        try {
          setLoading(false);
          const res = await axios.put(
            "/discount-code/apply",
            {
              "cart_id": getCardId(),
              "code": code
            },
            {
              headers: { 'Authorization': 'Bearer ' + getToken() }
            }
          );
          console.log(res.data)
          setLoading(true);
          if (res.data.errors) {
            MySwal.fire({
              text: translate('cart.error1'),
              icon: 'error',
              title: 'Oops...'
            })

          } else {
            setTotalPay(res.data.total)
            setDescuento(res.data.discount)

            MySwal.fire({
              text: translate('cart.addcod'),
              icon: 'success',
            })
          }
        } catch (error) {
          setLoading(true);
          MySwal.fire({
            text: error.response.data.message,
            icon: 'error',
            title: 'Oops...'
          })
        }
      } else {
        setLoading(true);
        MySwal.fire({
          text: translate('cart.error3'),
          icon: 'error',
          title: 'Oops...'
        })
      }

    } else {
      setLoading(true);
      MySwal.fire({
        text: translate('cart.error4'),
        icon: 'error',
        title: 'Oops...'
      })
    }

  }

  const handlerOcultar = () => {
    if (ocultar) {
      setSelectedDireccionId(false)
      setStreet1('')
      setStreet2('')
      setCp('')
      setDetail('')
      setCity('')
    }
    setOcultar(!ocultar)
  }

  const handlePostalCodeChange = async (e) => {
    const value = e.target.value;
    setCp(value);

    if (value.length >= 4) {
      try {

        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json`,
          {
            params: {
              address: countries.find(c => c.id == country).name + ' ' + value,
              key: API_KEY,
            },
          }
        );

        const results = response.data.results;
        if (results.length > 0) {

          const cities = results.reduce((acc, result) => {
            const addressComponents = result.address_components;
            console.log(addressComponents);

            // Filtra todos los componentes que coincidan con los tipos deseados
            const cityComponents = addressComponents.filter((component) =>
              component.types.includes("locality") ||
              component.types.includes("political") ||
              component.types.includes("postal_town")
            );

            // Agrega cada ciudad encontrada, evitando duplicados
            cityComponents.forEach((component) => {
              if (component.long_name && !acc.includes(component.long_name)) {
                acc.push(component.long_name);
              }
            });

            return acc;
          }, []);

          setCityOptions(cities);

          // Si solo hay una opción, la seleccionamos automáticamente
          if (cities.length === 1) {
            setCity(cities[0]);
          } else {
            setCity(""); // Limpiamos la ciudad si hay múltiples opciones
          }


        } else {
          setCityOptions([]);
          setCity("Sin resultados");
        }


      } catch (error) {
        console.error("Error al buscar la ciudad:", error);
        setCityOptions([]);
        setCity("Error de búsqueda");
      }
    } else {
      setCityOptions([]);
      setCity("");
    }
  };

  const guardar = async (type = 1) => {

    if (!street1) {
      MySwal.fire({
        text: translate('error.ae'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }
    if (!cp) {
      MySwal.fire({
        text: translate('error.cp'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }
    if (!city) {
      MySwal.fire({
        text: translate('error.city'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }
    try {

      setLoading(false)
      const dir = await axios[type == 1 ? 'post' : 'put'](
        type == 1 ? '/addresses/create' : '/addresses/update',
        {
          id: selectedDireccionId ? selectedDireccionId : null,
          country_id: country ?? 142,
          line: street1,
          line2: street2,
          postal_code: cp,
          city: city,
          details: detail,
          verified: getVerified(),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getToken()}`
          }
        }
      );

      MySwal.fire({
        text: translate('error.addresse'),
        icon: 'success',
      })

      setLoading(true)
      setOcultar(true)
      setSelectedDireccionId(dir.data.id)
      setStreet1('')
      setStreet2('')
      setCp('')
      setDetail('')
      setCity('')
      fetchDirecciones()

    } catch (error) {
      setLoading(true)
      MySwal.fire({
        text: translate('error.addressd'),
        icon: 'error',
        title: 'Oops...'
      })
      console.error('Error al guardar la dirección:', error);
    }


  };

  const fetchDirecciones = async () => {
    try {

      const storedToken = getToken();
      const verified = getVerified();

      if (storedToken) {
        setLoading(false)
        const response = await axios.get('/addresses/list?verified=' + (verified ? 1 : 0),
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${storedToken}`
            },
          }
        );
        setLoading(true)
        setDirecciones(response.data);
      }

    } catch (error) {
      setLoading(true)
      console.error('Error fetching address list', error);
    }
  };

  const continuar = async () => {

    if(!ocultar){
      MySwal.fire({
          text: translate('error.address_continue'),
          icon: 'error',
          title: 'Oops...'
        })
        return
    }

    if (!selectedDireccionId) {
      MySwal.fire({
        text: translate('error.address'),
        icon: 'error',
        title: 'Oops...'
      })
      return
    } else {

      try {

        const storedToken = getToken();

        setLoading(false)
        await axios.put('/cart/address?verified=' + (getVerified() ? 1 : 0),
          {

            "cart_id": getCardId(),
            "address_id": selectedDireccionId
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${storedToken}`
            },
          }
        );
        setLoading(true)
        navigate("/checkout-resumen")
      } catch (error) {
        setLoading(true)
        console.error('Error fetching address list', error);
            MySwal.fire({
              html: `${error.response.data}<br /><a class="link-mail" href="mailto:info@arteonu.com" target="_blank" rel="noopener noreferrer">${translate('checkout.contact')}</a>`,
              icon: 'error',
              title: 'Oops...'
            })
      }
    }
  }

  useEffect(() => {

    fetchDirecciones()

  }, [])

  return (
    <>
      {!loading && <Spinner />}

      <section className="CheckoutBox">

        <article>
          <div className="StepCheckout">
            <div className="Selected" onClick={() => !getVerified() ? navigate('/checkout-guest') : null} style={{ cursor: "pointer" }}></div>
            <div className="Selected"></div>
            <div></div>
            <div></div>
          </div>
          <div className="icon-HouseLine" onClick={() => navigate('/carrito')} style={{ cursor: "pointer" }}></div>

          <div className="CarritoResume">
            <h5>{translate('shopping.discount_code')} </h5>
            <p className="FontMedium">
              {translate('shopping.if_code')}
            </p>

            <div className="Row">
              <div className="FormInput">
                <input
                  placeholder={translate('shopping.discount_code')}
                  onChange={(e) => {
                    setCode(e.target.value.toUpperCase());
                  }}
                />
              </div>
              <div className="ButtonDarkMedium" onClick={() => { aplicarCupon() }}>{translate('shopping.apply')}</div>
            </div>

          </div>

          <h5>{translate('checkout.address')}</h5>

          <div className="DireccionesGuardadas">
            {direcciones.length > 0 &&
              <>
                <div>{translate('checkout.stored')}</div>
                <div className="FontSmall">
                  {translate('checkout.select')}
                </div>
              </>
            }
            {direcciones.length > 0 &&
              direcciones.map((direccion, index) => (
                <ItemDireccion
                  key={index}
                  direccion={direccion}
                  onSelect={handleSelect}
                  handleEditar={handleEditar}
                  selectedDireccionId={selectedDireccionId} // <-- Añade esta prop
                />
              ))}

            <div className="text-description">{translate('checkout.with_pay')} </div>

            <a className="link-mail" href="mailto:info@arteonu.com" target="_blank" rel="noopener noreferrer"> 
              {translate('checkout.contact')}
            </a>

            {ocultar &&
              <div className="ButtonLightMedium" onClick={() => handlerOcultar()}>
                <i>+</i>
                {translate('checkout.add_address')}
              </div>}
          </div>

          {!ocultar &&

            <div className="FormDireccion">
              <div>{translate('view.address.add_shipping')}</div>
              <div className="FontSmall">
                {translate('checkout.indicated')}
              </div>
              <label className="FormData">
                <em className="RequiredData">{translate('view.address.street_numer_apt_1')}</em>
                <div className="FormInputLight">
                  <input placeholder={translate('view.address.street_numer_apt_1')} onChange={(e) => { setStreet1(e.target.value) }} value={street1} />
                </div>
              </label>
              <label className="FormData">
                <em className="RequiredDataLine">{translate('view.address.street_numer_apt_2')}</em>
                <div className="FormInputLight">
                  <input placeholder={translate('view.address.street_numer_apt_2')} onChange={(e) => { setStreet2(e.target.value) }} value={street2} />
                </div>
              </label>
              <label className="FormData">
                <em className="RequiredData">{translate('login.country')}</em>
                <div className="FormInputLight">
                  <select onChange={(e) => {
                    const selectedCountryId = parseInt(e.target.value, 10); // Parse to integer
                    const selectedCountry = countries.find(country => country.id == selectedCountryId);
                    if (selectedCountry) {
                      setCountry(selectedCountry.id); // Assuming you still want to set the country ID
                    }
                  }}>
                    {countries &&
                      countries.map((pais) => (
                        <option key={pais.id} value={pais.id}
                          selected={(!country && pais.id === 142) || country == pais.id}
                        >
                          {pais.name}
                        </option>
                      ))}
                  </select>
                  <i className="InputIcon icon-Select"></i>
                </div>
              </label>

              <div className="Row">
                <label className="FormData">
                  <em className="RequiredData">{translate('view.address.postal_code')}</em>
                  <div className="FormInputLight">
                    <input placeholder={translate('view.address.postal_code')} onChange={handlePostalCodeChange} value={cp} />
                  </div>
                </label>
                <label className="FormData">
                  <em className="RequiredData">{translate('view.address.city')}</em>
                  <div className="FormInputLight">
                    <input
                      placeholder={translate('view.address.city')}
                      onChange={(e) => { setCity(e.target.value) }}
                      value={city}
                      list="cityOptions"
                    />
                    <datalist id="cityOptions">
                      {cityOptions.map((option, index) => (
                        <option key={index} value={option} />
                      ))}
                    </datalist>
                  </div>
                </label>
              </div>

              <label className="FormData">
                <em>{translate('view.address.detail')}</em>
                <div className="FormInputLight">
                  <textarea placeholder={translate('view.address.add_shipping')} onChange={(e) => { setDetail(e.target.value) }} value={detail}></textarea>
                </div>
              </label>
              <button className="ButtonLightMedium" onClick={() => { guardar(selectedDireccionId ? 2 : 1) }}>
                {selectedDireccionId ? translate('view.address.update') : translate('view.address.store')}
              </button>
            </div>

          }

          <div
            className="ButtonDarkMedium" style={{ marginTop: "13px" }}
            onClick={() => continuar()}
          >
            {translate('checkout.continue')}
            <i className="icon-Check"></i>
          </div>

        </article>

      </section>
    </>
  );
};

export default DireccionEnvio;
